import { HtEventsSnippet } from "@ht-sdks/events-sdk-js-browser";
import type { AnalyticsSnippet } from "@segment/analytics-next";
import { isClient } from "src/utils/isClient";

type AnalyticsProps = {
  analytics: AnalyticsSnippet;
  htevents: HtEventsSnippet;
};

export const getAnalytics = (): {
  analytics: AnalyticsSnippet;
  htevents: HtEventsSnippet;
} => {
  if (!isClient) {
    // analytics is only available in the client
    return {} as AnalyticsProps;
  }
  return { analytics: window.analytics, htevents: window.htevents };
};
